import { render } from "./formGroupTag.vue?vue&type=template&id=92b6b920"
import script from "./formGroupTag.vue?vue&type=script&lang=js"
export * from "./formGroupTag.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__